/**
 * Presentación compartida de las alertas de control de stock.
 *
 * Los tipos y severidades los define el backend (`inventario/alertas.py`);
 * acá vive solamente cómo se ven, para que el panel del dashboard y la
 * pantalla de detalle no se contradigan.
 */

export const ICONO_POR_TIPO = {
  sin_stock: 'mdi-package-variant-remove',
  stock_bajo: 'mdi-trending-down',
  conteo_abierto: 'mdi-clipboard-edit-outline',
  conteo_atrasado: 'mdi-clipboard-clock-outline',
};

export const COLOR_POR_SEVERIDAD = {
  critica: 'error',
  advertencia: 'warning',
  informativa: 'info',
};

export const ORDEN_SEVERIDAD = {
  critica: 0,
  advertencia: 1,
  informativa: 2,
};

// Alertas que abren un listado de productos. Las de conteo llevan al inventario.
export const TIPOS_CON_LISTADO = ['sin_stock', 'stock_bajo'];
